import styled from 'styled-components';

export const PersonTextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PersonApartmentInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PersonApartmentInfoText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  font-size: 14px;

  color: #4f4f4f;
`;

export const PersonNameText = styled.h3`
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 20px;
  margin-bottom: 4px;
  color: #333333;

  span {
    font-style: normal;
    font-weight: normal;
    line-height: 20px;
    font-size: 14px;

    color: #4f4f4f;
  }
`;

export const PerkItem = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-size: 12px;

  color: #212121;
`;

export const PerkImage = styled.img`
  margin-bottom: 8px;
`;

export const PerksContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${PerkItem} + ${PerkItem} {
    margin-left: 36px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/MatchComponents/PersonDetails.tsx